import { render, staticRenderFns } from "./LeadsList.vue?vue&type=template&id=5b3003de&"
import script from "./LeadsList.vue?vue&type=script&lang=js&"
export * from "./LeadsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports